import React, { ReactElement } from 'react';

import {
  Grid,
  GridItem,
  HStack,
  Image,
  Link,
  Spacer,
  Text,
  Tooltip,
  VStack,
} from '@chakra-ui/react';
import { IBenefitsBrokerSummary } from './interfaces';
import { brokerStyles } from './styles';
import copyTextIcon from '@assets/images/copyTextIcon.svg';

export function BenefitsBrokerSummary({
  brokerData,
  referralLink,
}: IBenefitsBrokerSummary): ReactElement {
  return (
    <VStack {...brokerStyles.container}>
      <Text {...brokerStyles.title}>Brokered Benefits Providers</Text>
      <Grid {...brokerStyles.gridContainer}>
        <GridItem area='signupLink' {...brokerStyles.gridItemBox}>
          <VStack spacing='0'>
            <HStack>
              <Text {...brokerStyles.title}>Referral Signup Link</Text>
              <Tooltip label='Copy to clipbaord'>
                <HStack
                  {...brokerStyles.editBox}
                  onClick={() => {
                    navigator.clipboard.writeText(referralLink);
                  }}
                >
                  <Text {...brokerStyles.signupLink} width={{ base: '220px', lg: '100%' }}>
                    {referralLink}
                  </Text>
                  <Spacer />
                  <Image {...brokerStyles.copyImage} alt='copy to clipboard' src={copyTextIcon} />
                </HStack>
              </Tooltip>
            </HStack>
            <Text {...brokerStyles.subValue}>
              Share this link with employers and others you are advising. Their subsiquent
              subscriptions will be credited to you
            </Text>
          </VStack>
        </GridItem>
        <GridItem area='benefitProviders' {...brokerStyles.gridItemBox}>
          <VStack width='100%'>
            <Text>Benefits Providers you&apos;ve referred: </Text>
            <ul>
              {brokerData?.affiliates.map((affiliate, index) => (
                <li key={index}>
                  <Link color='link' href={`https://${affiliate.website}`}>
                    {affiliate.entityName}
                  </Link>
                  {affiliate.accountStatus !== 'Active' && `(status: ${affiliate.accountStatus})`}
                  :&nbsp;
                  {affiliate.subscribersAnnualGroup +
                    affiliate.subscribersAnnualIndividual +
                    affiliate.subscribersMonthlyGroup +
                    affiliate.subscribersMonthlyIndividual}
                  &nbsp;active subs
                </li>
              ))}
            </ul>
          </VStack>
        </GridItem>
        <GridItem area='summaryStats' {...brokerStyles.gridItemBox}>
          <VStack width='100%'>
            <Text>Earnings</Text>
            <Text {...brokerStyles.subValue}>
              Earnings and payouts are calculated manually through an account reconciliation
              process, contact LVED for details
            </Text>
          </VStack>
        </GridItem>
      </Grid>
      {brokerData?.error && <Text {...brokerStyles.errorText}>{brokerData!.error}</Text>}
    </VStack>
  );
}

export default BenefitsBrokerSummary;
